import { createAction } from '@reduxjs/toolkit';

export const MESSAGE_RECEIVED = 'chat/message_received';
export const messageReceived = createAction<string>(MESSAGE_RECEIVED);
